import React from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import Detail from "./Detail";

const MrDepartmentIndex = () => {

  document.title = "Хэлтэс";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Үндсэн бүртгэл" breadcrumbItem="Хэлтэс" />
          <Detail />
        </div>
      </div>
    </React.Fragment>
  );
}


export default MrDepartmentIndex;